import axios from '../axios/axios';
import {
  FOREIGNTRAVEL_DATA_REQUEST,
  FOREIGNTRAVEL_DATA_SUCCESS,
  FOREIGNTRAVEL_DATA_FAIL,
} from '../constants/foreignTravelConstants';

export const foreignTravelAction = () => async (dispatch) => {
  try {
    dispatch({ type: FOREIGNTRAVEL_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s15',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: FOREIGNTRAVEL_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: FOREIGNTRAVEL_DATA_FAIL,
      payload: error,
    });
  }
};
